<template>
    <path d="M14.5 4.8H19V6.7H17.2V19.05C17.2 19.302 17.1052 19.5436 16.9364 19.7218C16.7676 19.8999 16.5387 20 16.3 20H3.7C3.46131 20 3.23239 19.8999 3.0636 19.7218C2.89482 19.5436 2.8 19.302 2.8 19.05V6.7H1V4.8H5.5V1.95C5.5 1.69804 5.59482 1.45641 5.7636 1.27825C5.93239 1.10009 6.1613 1 6.4 1H13.6C13.8387 1 14.0676 1.10009 14.2364 1.27825C14.4052 1.45641 14.5 1.69804 14.5 1.95V4.8ZM15.4 6.7H4.6V18.1H15.4V6.7ZM7.3 9.55H9.1V15.25H7.3V9.55ZM10.9 9.55H12.7V15.25H10.9V9.55ZM7.3 2.9V4.8H12.7V2.9H7.3Z"
          fill="#D82A1F"></path>
</template>

<script>
    export default {
        name: 'icon-trash'
    }
</script>